import { Box, Stack, styled, Typography } from '@mui/material'
import { type FC } from 'react'
import { useTranslation } from 'react-i18next'

import { COLORS } from '../../../../../../../../libs/ui/src/lib/constants'
import { unit } from '../../../../../../../../libs/ui/src/lib/utils'
import { isNotUndefined } from '../../../../../../../../libs/utils/src/lib/objects'
import { SENTRY_CONFIG } from '../../../../../configs'
import { useLastPath, useUserDetails } from '../../../../../contexts'
import { useRelogin } from '../../../../../hooks/api/b2c'
import { ButtonSignOut } from '../../../button-sign-out'
import { LayoutNavigationBackError500 } from '../../../layout-navigation-back'
import { Metadata } from '../../../metadata'

import { NavigationLinks } from './navigation-links'
import { NavigationMenuDrawer } from './navigation-menu-drawer'

interface NavigationMenuProps {
  isVisible: boolean
  setIsVisible: (isVisible: boolean) => void
}

export const NavigationMenu: FC<NavigationMenuProps> = ({ setIsVisible, isVisible }) => {
  const { t } = useTranslation()
  const lastPath = useLastPath()
  const userDetails = useUserDetails()

  useRelogin()

  if (userDetails.isError) {
    return <LayoutNavigationBackError500 to={lastPath.root} />
  }

  if (userDetails.isSuccess && isNotUndefined(userDetails.data)) {
    return (
      <NavigationMenuDrawer setIsVisble={setIsVisible} isVisble={isVisible}>
        <Metadata title={t('page-title.account')} />
        <Header>
          <Typography
            component='h2'
            variant='headlineM'
            color={COLORS.red['dark']}
            className={SENTRY_CONFIG.privacy.className}
            aria-label={userDetails.data.first_name}
            letterSpacing={unit(0.028)}
            id='modal-title'
          >
            {userDetails.data.first_name} {userDetails.data.last_name}
          </Typography>
          <Typography
            className={SENTRY_CONFIG.privacy.className}
            component='p'
            variant='bodyM'
            letterSpacing={unit(0.01)}
          >
            {userDetails.data.email}
          </Typography>
        </Header>
        <NavigationLinks isLogged={true} isOwner={userDetails.data.has_active_contracts} />
        <Footer>
          <ButtonSignOut variant='outlined' color='black' />
        </Footer>
      </NavigationMenuDrawer>
    )
  }
}

const Header = styled(Stack)`
  padding: ${unit(10.5)} ${unit(5.5)} ${unit(6)} ${unit(5.5)};
`

const Footer = styled(Box)`
  padding: ${unit(6)} ${unit(5)};
`
